import teammate from 'assets/teammate.png'
import emailTemplates from 'assets/email_templates.png'
import integrations from 'assets/integrations_v2.png'
import kb from 'assets/kb-eCommerce.png'
import rule from 'assets/rules.png'
import inbox from 'assets/inbox_empty.png'
import widget from 'assets/widget.png'
import creditCard from 'assets/creditcards/credit-card-lg.png'

import {
  DRAWER_TYPE_AGENT_ADD,
  DRAWER_TYPE_CANNED_REPLIES_UPDATE,
} from 'ducks/drawers/types'
import {
  SETTINGS_BILLING_PAGE,
  SETTINGS_INTEGRATIONS_PAGE,
  SETTINGS_RULES_PAGE,
  SETTINGS_WIDGET_CREATE_NEW_PAGE,
} from 'subapps/settings/types'
import { LANDING_PAGE } from 'subapps/kb/pages'

export const onboardingWorkflowData = {
  mailbox: {
    name: `Create ${app.t('Mailbox_with_article')}`,
    img: inbox,
    imgWidth: 278,
    imgHeight: 218,
    title: 'Get your email flowing into Groove!',
    subtitle: `Let’s get your emails flowing in by connecting your first ${app.t(
      'mailbox'
    )} to your Groove account.`,
    note: 'Setup time of 2 minutes or less',
    skippable: false,
    usageKey: 'mailboxes_created',
  },
  widget: {
    name: 'Setup a Help Widget',
    img: widget,
    imgWidth: 515,
    imgHeight: 252,
    title: 'Epic support on every page of your site!',
    subtitle: `Whether you need a simple contact form, an integrated knowledge base, live chat, or all three, the Groove Help Widget is ready for the job.`,
    note: 'Setup time of 3 minutes',
    btnLabel: 'Create your Help Widget',
    to: { type: SETTINGS_WIDGET_CREATE_NEW_PAGE },
    usageKey: 'widget_created',
    flagName: 'skip_onboarding_widget',
    // isBool: whether the usage value is boolean
    // for updating the data locally in doTryFetchAccountUsageOnboardingForOnboarding
    isBool: true,
  },
  rule: {
    name: 'Add a Rule',
    img: rule,
    imgWidth: 278,
    imgHeight: 218,
    title: 'Automate tedious tasks with rules!',
    subtitle: `With rules, you can set up powerful automations to take care of repetitive tasks using simple if/then logic.`,
    note: 'Setup time of 3 minutes',
    btnLabel: 'View all our Rule templates',
    to: {
      type: SETTINGS_RULES_PAGE,
      payload: {
        tab: 'templates',
      },
    },
    usageKey: 'automation_rules_created',
    flagName: 'skip_onboarding_rule',
  },
  canned_reply: {
    name: `Create ${app.t('Canned_Reply_with_article')}`,
    img: emailTemplates,
    imgWidth: 263,
    imgHeight: 207,
    title: `Respond 45% faster with ${app.t('Canned_Replies')}!`,
    subtitle: `Create a searchable library of answers to frequently asked questions, then insert them into replies in two clicks.`,
    note: 'Setup time of 3 minutes',
    btnLabel: `Create your first ${app.t('Canned_Reply')}`,
    drawerType: DRAWER_TYPE_CANNED_REPLIES_UPDATE,
    flagName: 'skip_onboarding_canned_reply',
    usageKey: 'comment_templates_created',
  },
  kb: {
    name: 'Create a Knowledge Base',
    img: kb,
    imgWidth: 477,
    imgHeight: 237,
    title: 'Cut your support volume down by 30%',
    subtitle: `Our fully customizable Knowledge Base lets customers find their own answers quickly, making them happier, and your team more productive.`,
    note: 'Setup time of 5 minutes',
    btnLabel: `Create your Knowledge base`,
    to: { type: LANDING_PAGE },
    usageKey: 'kb_created',
    flagName: 'skip_onboarding_kb',
    isBool: true,
  },
  integration: {
    name: 'Add an Integration',
    img: integrations,
    imgWidth: 434,
    imgHeight: 255,
    title: 'Supercharge Groove with integrations',
    subtitle: `Connect Groove with the apps you use daily to supercharge your team's workflow and keep everything in one place.`,
    note: 'Setup time of 1 minute',
    btnLabel: 'Get connected!',
    to: { type: SETTINGS_INTEGRATIONS_PAGE },
    flagName: 'skip_onboarding_integration',
    usageKey: 'integrations_installed',
    isBool: true,
  },
  teammates: {
    name: `Invite ${app.t('Agents')}`,
    img: teammate,
    imgWidth: 380,
    imgHeight: 299,
    title: 'Ready to bring on the team?',
    subtitle: `Invite any ${app.t(
      'agent'
    )} that needs access to this inbox to your Groove
    account.`,
    note: 'Setup time of 1 minute',
    btnLabel: `Invite ${'agents'}!`,
    drawerType: DRAWER_TYPE_AGENT_ADD,
    usageKey: 'agents_invited',
    flagName: 'skip_onboarding_agents',
  },
  payment_method: {
    name: 'Add a Payment Method',
    img: creditCard,
    imgWidth: 303,
    imgHeight: 217,
    title: 'Add your payment method',
    subtitle: `Ensure your account isn't cut off at the end of your trial. You will only be billed once your trial ends.`,
    btnLabel: 'Go to billing page',
    to: {
      type: SETTINGS_BILLING_PAGE,
    },
    flagName: 'skip_onboarding_payment_method',
    usageKey: 'payment_method_created',
    isBool: true,
  },
}
